module.exports = __webpack_public_path__ + "img/index-3-pic01@2x.87068f6f.png";